"use client";

import { useTrackIntersectionObserver } from "./useTrackIntersectionObserver";
import { TrackingEvent } from "../types";
import { useTrackOnMount } from "./useTrackOnMount";

type TrackingMethod =
  | { method?: "on-mount"; selector?: undefined }
  | {
      method: "in-viewport";
      selector: `#${string}` | `[${string}]` | `.${string}`;
    };

export type TrackProps = {
  event: TrackingEvent | null;
} & TrackingMethod;

function Component({ event, method = "on-mount", selector }: TrackProps) {
  useTrackOnMount(event, method === "on-mount");

  useTrackIntersectionObserver(
    event ?? undefined,
    method === "in-viewport",
    selector,
  );

  return null;
}
export const Track = Component;
